// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkogqwt{border-radius:var(--ds-border-radius-050,2px)}._12y3ssc3{outline-width:var(--ds-border-width,2px)}\n._16qs1dt4{box-shadow:var(--_qzf6oc)}\n._1e0c1ule{display:block}\n._bfhk1rd0{background-color:var(--_14yez9t)}\n._mizu1tqa:focus-visible{outline-color:var(--_9ksfq)}\n._ra3xnqa1:focus-visible{outline-style:solid}", ""]);
// Exports
module.exports = exports;
